/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Appointment } from '../models/appointment';
import { AppointmentPartial } from '../models/appointment-partial';
import { AppointmentWithRelations } from '../models/appointment-with-relations';
import { Count } from '../models/count';

@Injectable({
  providedIn: 'root',
})
export class UserControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation userControllerFindAppointments
   */
  static readonly UserControllerFindAppointmentsPath = '/users/{id}/appointment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAppointments()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAppointments$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<AppointmentWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerFindAppointmentsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AppointmentWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAppointments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAppointments(params: {
    id: string;
    filter?: any;
  }): Observable<Array<AppointmentWithRelations>> {

    return this.findAppointments$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AppointmentWithRelations>>) => r.body as Array<AppointmentWithRelations>)
    );
  }

  /**
   * Path part for operation userControllerCreateAppointment
   */
  static readonly UserControllerCreateAppointmentPath = '/users/{id}/appointment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAppointment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAppointment$Response(params: {
    id: string;
    body?: Appointment
  }): Observable<StrictHttpResponse<Appointment>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerCreateAppointmentPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Appointment>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createAppointment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAppointment(params: {
    id: string;
    body?: Appointment
  }): Observable<Appointment> {

    return this.createAppointment$Response(params).pipe(
      map((r: StrictHttpResponse<Appointment>) => r.body as Appointment)
    );
  }

  /**
   * Path part for operation userControllerDeleteAppointment
   */
  static readonly UserControllerDeleteAppointmentPath = '/users/{id}/appointment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAppointment()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAppointment$Response(params: {
    id: string;
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerDeleteAppointmentPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteAppointment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAppointment(params: {
    id: string;
    where?: any;
  }): Observable<Count> {

    return this.deleteAppointment$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation userControllerPatchAppointment
   */
  static readonly UserControllerPatchAppointmentPath = '/users/{id}/appointment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchAppointment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchAppointment$Response(params: {
    id: string;
    where?: any;
    body?: AppointmentPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, UserControllerService.UserControllerPatchAppointmentPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `patchAppointment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchAppointment(params: {
    id: string;
    where?: any;
    body?: AppointmentPartial
  }): Observable<Count> {

    return this.patchAppointment$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

}
